import { useCallback, useMemo } from 'react';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import {
  RecordOpenMode,
  useCreateUserSettingValue,
  UserSettingId,
  useUpdateUserSettingValue,
} from 'src/graphql/entities/user-setting-value';

export function useRecordOpenMode() {
  const { user } = useCurrentUserProfile();

  const currentOpenMode = useMemo(
    () => user?.userSettingValueMap.get(UserSettingId.RecordOpenMode),
    [user?.userSettingValueMap],
  );

  const { createUserSettingValue } = useCreateUserSettingValue();
  const { updateUserSettingValue } = useUpdateUserSettingValue();

  const changeRecordOpenMode = useCallback(
    (openMode: RecordOpenMode) => {
      if (currentOpenMode) {
        updateUserSettingValue(currentOpenMode.userSettingValue, {
          value: openMode,
        });
      } else {
        createUserSettingValue({
          userSettingId: UserSettingId.RecordOpenMode,
          value: openMode,
          valueType: 'string',
        });
      }
    },
    [createUserSettingValue, currentOpenMode, updateUserSettingValue],
  );

  return useMemo(
    () => ({
      changeRecordOpenMode,
      currentOpenMode: (currentOpenMode?.value as RecordOpenMode) || RecordOpenMode.SidePeek,
    }),
    [changeRecordOpenMode, currentOpenMode?.value],
  );
}
